var swiper;
import '../styles/index.scss';
import '@fortawesome/fontawesome-free/js/fontawesome';
import '@fortawesome/fontawesome-free/js/solid';
import '@fortawesome/fontawesome-free/js/regular';
import '@fortawesome/fontawesome-free/js/brands';

//import $ from 'jquery'
import WebApp from './app.js';
import Mobile from './mobile.js'
;(function () {
  let Page = new WebApp(swiper);
  let MobilePage = new Mobile();
  Page.init();
  MobilePage.init();
})();
